<template>
    <v-dialog :value="isOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card color="black" tile>
            <v-toolbar dark color="secondary">
                <v-btn icon dark @click="qrCodeStreamStop">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-toolbar-title>Znajdź kod QR</v-toolbar-title>

                <v-spacer />

                <v-menu offset-y>
                    <template #activator="{on}">
                        <v-btn
                            dark
                            icon
                            v-on="on"
                        >
                            <v-icon>mdi-cog</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-subheader>Domyślna kamera</v-subheader>
                        <v-list-item
                            v-for="(camera, index) in cameras"
                            :key="index"
                            @click="setDefaultCamera(camera)"
                        >
                            <v-list-item-title>
                                {{ camera.label }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>

            <video id="qrStreamContainer" class="qrcode-stream__camera" />
        </v-card>
    </v-dialog>
</template>

<script>
import { BrowserQRCodeReader } from '@zxing/library'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'CodeReaderDialog',
    props: {
        settings: {
            type: Object,
            default: null
        },
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            codeReader: null,
            cameras: [],
            defaultCameraId: null
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.qrCodeStreamStart(this.settings)
            }
        }
    },
    created() {
        this.codeReader = new BrowserQRCodeReader()
        this.qrCodeStreamGetCameras()
    },
    methods: {
        qrCodeStreamGetCameras() {
            this.codeReader.getVideoInputDevices()
                .then(videoInputDevices => {
                    this.cameras = []
                    videoInputDevices.forEach(device => {
                        this.cameras.push(device)
                    })
                    this.$store.dispatch('setDeviceCameras', this.cameras)

                    if (this.cameras.length === 0) return

                    this.defaultCameraId = localStorage.getItem('defaultCameraId') || this.cameras[this.cameras.length - 1].deviceId
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        qrCodeStreamStart(settings) {
            const expectedQrTypeCodes = settings && settings.expectedQrTypeCodes
            const origin = settings && settings.origin

            this.$emit('code-stream-start', settings)

            this.codeReader.decodeFromInputVideoDevice(this.defaultCameraId, 'qrStreamContainer')
                .then(response => {
                    const qrObject = JSON.parse(response.text)
                    const audio = new Audio('/sounds/beep.mp3')

                    audio.play()
                    window.navigator.vibrate(200)

                    if (expectedQrTypeCodes.includes(qrObject.type)) {
                        this.$emit('code-stream-handle', {
                            data: qrObject,
                            origin: origin
                        })
                    } else {
                        this.$store.dispatch('showNotification', {
                            type: 'error',
                            message: this.$i18n.t('reports.messages.unsupportedQrCode')
                        })
                    }
                    this.qrCodeStreamStop()
                })
                .catch(error => {
                    this.$store.dispatch('showNotification', {
                        type: 'error',
                        message: `Błąd kamery: ${error.name}`
                    })
                    this.qrCodeStreamStop()
                    this.qrCodeStreamGetCameras()
                    localStorage.removeItem('defaultCameraId')

                    errorHandler(error)
                })
        },
        qrCodeStreamStop() {
            this.codeReader.reset()
            this.$emit('code-stream-stop')
        },
        setDefaultCamera(camera) {
            this.defaultCameraId = camera.deviceId
            this.qrCodeStreamStop()
            this.qrCodeStreamStart(this.settings)
            localStorage.setItem('defaultCameraId', camera.deviceId)
        },
    }
}
</script>